module.exports = __webpack_public_path__ + "static/media/pragmatic_play.29a236b8.svg";